
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import regular from "@/common/regular";
import { getAllOperList } from "@/api/api-basic";
import { addNotice, updateNotice, getNoticeDetails } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component
export default class OperatorPostNoticeAdd extends Vue {
  private modalShow = false;
  private loading = false;
  private allCheckbox = false;
  private modalTitle = i18n.t("postNotice.add");
  private FormData: objAny = {};
  private searchValue = "";
  private validateOper = (
    rule: objAny,
    value: string[],
    callback: Function
  ) => {
    if (value.length == 0) {
      callback(new Error(i18n.t("postNotice.operPl") + ""));
    } else {
      callback();
    }
  };
  private ruleInline: objAny = {
    title: [
      {
        required: true,
        message: i18n.t("postNotice.titlePl"),
        trigger: "blur"
      }
    ],
    content: [
      {
        required: true,
        message: i18n.t("postNotice.contentPl"),
        trigger: "blur"
      }
    ],
    oprList: [
      {
        required: true,
        validator: this.validateOper,
        trigger: "change"
      }
    ],
    email: [
      {
        required: true,
        message: i18n.t("postNotice.emailPl"),
        trigger: "blur",
        type: "number"
      }
    ]
  };

  private formItem: objAny = {
    title: "",
    content: "",
    oprList: [],
    email: 1,
    noticePkId: ""
  };

  private oprList: objAny[] = [];
  private disabled = false;
  private pageType = "";
  public open(type: string, item?: objAny) {
    this.searchValue = "";
    this.pageType = type;
    this.modalShow = true;
    this.allCheckbox = false;
    this.modalTitle =
      type == "add"
        ? i18n.t("postNotice.add")
        : type == "details"
        ? i18n.t("postNotice.details")
        : i18n.t("postNotice.updata");
    if (type == "details") {
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    this.formItem.noticePkId = "";
    this.formItem.title = "";
    this.formItem.content = "";
    this.formItem.oprList = [];
    this.formItem.email = 1;
    if (item) {
      this.formItem.noticePkId = item.noticePkId;
      this.getNoticeDetails();
    }
    this.getStation();
  }

  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  public allChange(): void {
    if (this.allCheckbox) {
      this.formItem.oprList = this.oprList.map((item: objAny) => {
        return item.oprPkId;
      });
    } else {
      this.formItem.oprList = [];
    }
  }
  public handleSubmit() {
    const formItem: objAny = this.$refs.formInline;
    formItem.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    let ret;
    if (this.pageType == "add") {
      ret = await addNotice(this.formItem);
    } else {
      ret = await updateNotice(this.formItem);
    }

    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  async getStation(): Promise<void> {
    const ret = await getAllOperList({
      filter: 1
    });
    if (ret.status === this.$config.apiStatus) {
      this.oprList = ret.data;
    }
  }
  async getNoticeDetails(): Promise<void> {
    const ret = await getNoticeDetails({
      noticePkId: this.formItem.noticePkId
    });
    if (ret.status === this.$config.apiStatus) {
      const data: objAny = ret.data[0] || {};
      this.formItem.title = data.title;
      this.formItem.content = data.content;
      this.formItem.oprList = data.oprList;
      this.formItem.email = data.email;
    }
  }

  get operListShow() {
    if (this.searchValue == "") {
      return this.oprList;
    } else {
      const list = this.oprList.filter((item: objAny) => {
        return item.oprName.indexOf(this.searchValue) != -1;
      });
      return list;
    }
  }
}
